import {CellProps} from '../index';

export const RegisterCell = ({value, task}: CellProps) => {
  return <p>{value}</p>;
};
